import BaseButton from "../../../components/ui/BaseButton";
import BaseWrapper from "../../../components/ui/BaseWrapper";
import { useNavigate } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import { ROLES } from "../../../utils/variables";
import { useState } from "react";
import { useCurrentUser } from "../../../hooks/useCurrentUser";
import CompleteProfileModal from "../../WorkJobDetails/CompleteProfileModal";
import { ModuleType } from "../../../utils/enum";
const ClientDashboardHeader = () => {
  const naviagte = useNavigate();
  const { authRole, getPermissionForModule } = useAuth();
  const { hasWriteAccess } = getPermissionForModule(ModuleType.CLIENT_CUSTOMER);
  const { userData } = useCurrentUser();
  const [isProfileCompleted, setIsProfileCompleted] = useState(false);

  const handleNewClient = () => {
    if (!isProfileCompleted) {
      naviagte("/workBoard/clients/create?isParentClient=true");
    }
  };

  return (
    <div className="border-b border-zinc-300 bg-white ">
      <BaseWrapper>
        <div className="grid grid-cols-7 gap-y-3 py-[7px] items-center">
          <div className="md:col-span-2 col-span-7">
            <h3 className="font-light md:text-left text-center">Customer Dashboard</h3>
          </div>
          {authRole !== ROLES.FREELANCE && hasWriteAccess && (
            <div className="md:col-span-5 col-span-7 flex  justify-end">
              <BaseButton
                className="md:w-auto w-full"
                variant="contained"
                color="primary"
                style={{
                  paddingTop: "6px",
                  paddingBottom: "6px",
                  paddingLeft: "12px",
                  paddingRight: "12px",
                }}
                onClick={() => {
                  if (userData?.status !== "APPROVED") {
                    setIsProfileCompleted(true);
                    return;
                  }
                  handleNewClient();
                }}
              >
                Create Parent Customer
              </BaseButton>
            </div>
          )}
        </div>
      </BaseWrapper>
      {isProfileCompleted && (
        <CompleteProfileModal
          isProfileCompleted={isProfileCompleted}
          setIsProfileCompleted={setIsProfileCompleted}
          status={userData?.status}
          authRole={authRole}
        />
      )}
    </div>
  );
};

export default ClientDashboardHeader;
